import React from 'react';
import { Alert } from 'reactstrap';
import styles from './index.module.scss';
import { AlertProps } from './types';

const { primaryAlert } = styles;

export const AlertPrimary = (props: AlertProps) => <Alert data-testid={props.testId} color='primary' className={primaryAlert}>{props.children}</Alert>;
